import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/dashboard`;

/**
 * Helper para enviar filtros al backend
 */
function withParams(params) {
  return { params: params || {} };
}

// ------------------- EXISTENTES -------------------
export function getTotales(params) {
  return axios.get(`${baseUrl}/totales`, withParams(params));
}

export function getVerificacionDiaria(params) {
  return axios.get(`${baseUrl}/verificacion-diaria`, withParams(params));
}

export function getPorUbicacion(params) {
  return axios.get(`${baseUrl}/por-ubicacion`, withParams(params));
}

export function getLlamadas(params) {
  return axios.get(`${baseUrl}/llamadas`, withParams(params));
}

export function getDistribuciones(params) {
  return axios.get(`${baseUrl}/distribuciones`, withParams(params));
}

export function getActividadReciente(params) {
  return axios.get(`${baseUrl}/actividad-reciente`, withParams(params));
}

// -------- Tarjetas nuevas -----------
export function getMetricasLlamadas(params) {
  return axios.get(`${baseUrl}/metricas-llamadas`, withParams(params));
}

export function getTasaExito(params) {
  return axios.get(`${baseUrl}/tasa-exito`, withParams(params));
}

export function getPromedioLlamadasDia(params) {
  return axios.get(`${baseUrl}/promedio-llamadas-dia`, withParams(params));
}

// ------------------- NUEVOS ENDPOINTS -------------------
export function getIntentosValidacion(params) {
  return axios.get(`${baseUrl}/intentos-validacion`, withParams(params));
}

export function getNoVerificadosTotales(params) {
  return axios.get(`${baseUrl}/no-verificados-totales`, withParams(params));
}

export function getExportData(params) {
  return axios.get(`${baseUrl}/export`, withParams(params));
}

// ------------------- NUEVO ENDPOINT: DISTRIBUCIÓN POR GÉNERO -------------------
export function getDistribucionPorGenero(filters, genero) {
  return axios.get(`${baseUrl}/distribucion-genero`, {
    params: {
      ...filters,
      genero
    }
  });
}


// En dashboardService.js, agrega esta función al final:

export function getEfectividadPorIntentos(params) {
  return axios.get(`${baseUrl}/efectividad-intentos`, withParams(params));
}